<ng-container *ngIf="card && card.wm2eStatus && card.wm2eInfo">
  <div *ngIf="!editMode" class="flexRow" style="justify-content: space-between; width: 100%; align-items: center">
    <dx-button
      *ngIf="card.wm2eInfo.originType === WriteOnEdgeOriginTypeEnum.USER && card.wm2eStatus.commandStatus !== WriteOnEdgeStatusEnum.CREATED && card.wm2eStatus.commandStatus !== WriteOnEdgeStatusEnum.RUNNING"
      stylingMode="text"
      (onClick)="startEditMode()">
      <i class="vf-ic_fluent_arrow_sort_24_filled"></i>
    </dx-button>

    <i *ngIf="card.wm2eInfo.originType === WriteOnEdgeOriginTypeEnum.SYSTEM"
       id="system-writeable-icon-{{card.id}}"
       class="dx-icon system-write-icon vf-ic_fluent_arrow_between_down_24_filled">
    </i>

    <div
      *ngIf="card.wm2eStatus.commandStatus === WriteOnEdgeStatusEnum.CREATED || card.wm2eStatus.commandStatus === WriteOnEdgeStatusEnum.RUNNING">
      {{ 'DASHBOARD.METRIC_CARD.WRITING_VALUE' | translate }}: {{ getValueToWriteParsed() }}
    </div>
    <div
      *ngIf="card.wm2eStatus.commandStatus === WriteOnEdgeStatusEnum.CREATED || card.wm2eStatus.commandStatus === WriteOnEdgeStatusEnum.RUNNING">
      <dx-load-indicator height="24" width="24"></dx-load-indicator>
    </div>
    <div class="metricWriteErrorContainer" *ngIf="card.wm2eStatus.commandStatus === WriteOnEdgeStatusEnum.COMPLETED_KO">
      <span id="error-message-{{card.id}}" class="metricWriteErrorMessage">{{'DASHBOARD.METRIC_CARD.WRITE_KO' | translate}}</span>
      <i id="error-icon-{{card.id}}" class="vr-ic_fluent_error_circle_24_regular metricWriteErrorMessage"></i>
    </div>
    <div *ngIf="card.wm2eStatus.commandStatus === WriteOnEdgeStatusEnum.COMPLETED_TIMEOUT">
      <i id="timeout-icon-{{card.id}}" class="vr-ic_fluent_timer_off_24_regular" style="color: var(--keton-alarm-offline)"></i>
    </div>
    <div *ngIf="card.wm2eStatus.commandStatus === WriteOnEdgeStatusEnum.COMPLETED_OK">
      <i class="vr-ic_fluent_checkmark_24_regular" style="color: var(--keton-alarm-ok)"></i>
    </div>
  </div>

  <dx-tooltip
    target="#system-writeable-icon-{{card.id}}"
    position="top"
    hideEvent="dxhoverend dxfocusout"
    showEvent="dxhoverstart dxfocusin">
    <div *dxTemplate="let _ of 'content'">
      <span>
        {{'DASHBOARD.METRIC_CARD.SYSTEM_WRITEABLE' | translate }}
      </span>
    </div>
  </dx-tooltip>

  <dx-tooltip
    target="#error-icon-{{card.id}}, #timeout-icon-{{card.id}}"
    position="top"
    [wrapperAttr]="{class: 'tooltip-error'}"
    hideEvent="dxhoverend dxfocusout"
    showEvent="dxhoverstart dxfocusin">
    <div *dxTemplate="let _ of 'content'">
      <span>
        {{ card.wm2eStatus.koMessage?? 'DASHBOARD.METRIC_CARD.WRITE_KO' | translate }}
      </span>
    </div>
  </dx-tooltip>


  <dx-validation-group #validationGroup class="formContainer" *ngIf="editMode">
    <div class="formFieldContainer">
      <dx-text-box
        [maxLength]="1"
        valueChangeEvent="keyup focusout"
        *ngIf="card.dataTypeGroup === DataTypeGroupEnum.STRING"
        [(value)]="newValue">
        <dx-validator>
          <dxi-validation-rule
            type="required"
            [message]="translate.instant('VALIDATION.REQUIRED')">
          </dxi-validation-rule>
        </dx-validator>
      </dx-text-box>

      <app-hex-text-box
        *ngIf="card.dataTypeGroupShowAsHex"
        [card]="card"
        [(value)]="newValue">
      </app-hex-text-box>

      <dx-number-box
        *ngIf="card.dataTypeGroup === DataTypeGroupEnum.INTEGER && !card.dataTypeGroupShowAsHex"
        [showSpinButtons]="true"
        [step]="1"
        [value]="newValue"
        valueChangeEvent="keyup focusout"
        (onValueChanged)="roundAndAssignValue($event)">
        <dx-validator>
          <dxi-validation-rule
            *ngIf="card.dataTypeGroupMin !== null"
            type="range"
            [min]="card.dataTypeGroupMin"
            [message]="translate.instant('VALIDATION.MIN_VALUE', { min: card.dataTypeGroupMin })">
          </dxi-validation-rule>
          <dxi-validation-rule
            *ngIf="card.dataTypeGroupMax !== null"
            type="range"
            [max]="card.dataTypeGroupMax"
            [message]="translate.instant('VALIDATION.MAX_VALUE', { max: card.dataTypeGroupMax })">
          </dxi-validation-rule>
        </dx-validator>
      </dx-number-box>

      <dx-number-box
        *ngIf="card.dataTypeGroup === DataTypeGroupEnum.FLOAT && !card.dataTypeGroupShowAsHex"
        [showSpinButtons]="true"
        [step]="getNumberBoxStep(card.decimalDigits)"
        valueChangeEvent="keyup focusout"
        [(value)]="newValue">
        <dx-validator>
          <dxi-validation-rule
            *ngIf="card.dataTypeGroupMin !== null"
            type="range"
            [min]="card.dataTypeGroupMin"
            [message]="translate.instant('VALIDATION.MIN_VALUE', { min: card.dataTypeGroupMin })">
          </dxi-validation-rule>
          <dxi-validation-rule
            *ngIf="card.dataTypeGroupMax !== null"
            type="range"
            [max]="card.dataTypeGroupMax"
            [message]="translate.instant('VALIDATION.MAX_VALUE', { max: card.dataTypeGroupMax })">
          </dxi-validation-rule>
        </dx-validator>
      </dx-number-box>

      <dx-switch
        *ngIf="card.dataTypeGroup === DataTypeGroupEnum.BOOLEAN"
        (onValueChanged)="newValue = $event.value"
        [value]="newValue === 'true' || newValue === true">
      </dx-switch>
      <span *ngIf="card.dataTypeGroup === DataTypeGroupEnum.BOOLEAN">{{appService.translateMaybeBoolean(newValue)}}</span>
    </div>

    <div class="formButtonsContainer">
      <dx-button
        [disabled]="!isFormValid()"
        (onClick)="writeNewMetricValue()"
        stylingMode="text">
        <i class="vr-ic_fluent_checkmark_24_regular"></i>
      </dx-button>
      <dx-button
        (onClick)="undoWriteNewMetricValue()"
        stylingMode="text">
        <i class="vr-ic_fluent_arrow_undo_24_regular"></i>
      </dx-button>
    </div>
  </dx-validation-group>
</ng-container>
